export default __webpack_public_path__ + "static/icons-survey-f4e1a442bebbfcdf9fef0b8b16f54968.png";